import { render, staticRenderFns } from "./OrderBadgePanel.vue?vue&type=template&id=15053783&scoped=true"
import script from "./OrderBadgePanel.vue?vue&type=script&lang=js"
export * from "./OrderBadgePanel.vue?vue&type=script&lang=js"
import style0 from "./OrderBadgePanel.vue?vue&type=style&index=0&id=15053783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15053783",
  null
  
)

export default component.exports